import { useState, useEffect, useCallback } from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

import Pagination from "../../../components/common/Pagination";
import Table from "../../../components/common/Table";
import Toaster from "../../../components/common/Toaster";

import taxService from "../../../services/taxService";
import moment from "moment";

const ReceiptTable = ({ data, columns, options, onChange, setData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const response = await taxService.getReceiptsAsync(options);
        const { result, page, total_count } = response;
        const items = result.map((item) => {
          item["name"] = (
            <Link to={`/accounts/${item.account_id}/receipts`}>
              {item.first_name} {item.last_name}
            </Link>
          );

          item["verified"] = item.client_name ? (
            <IoCheckmarkCircleOutline className="text-green-500" />
          ) : (
            ""
          );

          item["created_on"] = moment(item.created_on).format("LL");

          return item;
        });

        if (mounted) {
          setData(items);
          setCurrentPage(page);
          setTotalCount(total_count);
          setIsLoading(false);
        }
      } catch (ex) {
        setIsLoading(false);
        Toaster.Error("Something went wrong.");
      }
    },
    [options, setData]
  );

  const handleSort = (sort_column) => {
    const new_options = { ...options };
    new_options.sort_column = sort_column;
    onChange(new_options);
  };

  const handlePageChange = (page) => {
    const new_options = { ...options };
    new_options.current_page = page;
    onChange(new_options);
  };

  useEffect(() => {
    let mounted = true;

    fetchData(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchData]);

  return (
    <div className="mt-10 overflow-auto lg:overflow-visible">
      <Table
        data={data}
        columns={columns}
        sortColumn={options.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={options.size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default ReceiptTable;
